import { render, staticRenderFns } from "./TrainingEcgRealTime.vue?vue&type=template&id=437045fc&"
import script from "./TrainingEcgRealTime.vue?vue&type=script&lang=js&"
export * from "./TrainingEcgRealTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports